import moment from 'moment';
import templateUrl from './edit-multi-play-commission-policy.component.html';

export const EditMultiPlayCommissionPolicyComponent = {
    require: {
        editForm: "^^form"
    },
    controller: EditMultiPlayCommissionPolicyController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        multiPlayCommissionPolicy: "<",
        products: "<",
        productLines: "<",
        divisions: "<",
        onSave: "&",
        onDelete: "&",
        onValidate: "&",
        onEditOtherPolicy: "&"
    }
};

function EditMultiPlayCommissionPolicyController(productCommissionPolicyArchiveService) {
    'ngInject';
    const vm = this;

    vm.$onInit = $onInit;
    vm.multiPlayCommissionPolicy;
    vm.products;
    vm.productLines;
    vm.divisions;
    vm.onDelete;
    vm.onValidate;
    vm.filteredProductLines;
    vm.filterProductLine = filterProductLine;
    vm.filterVisibleProductLine = filterVisibleProductLine;
    vm.onAddProductLine = onAddProductLine;
    vm.onDeleteProductLine = onDeleteProductLine;
    vm.onChange = onChange;
    vm.filteredMultiPlays;
    vm.onChangeDivision = onChangeDivision;
    vm.onArchiveChange = onArchiveChange;
    vm.onAddPolicy = onAddPolicy;
    vm.onDeleteArchive = onDeleteArchive;

    function $onInit() {
        if (!vm.multiPlayCommissionPolicy.IsNew && vm.multiPlayCommissionPolicy.DivisionID) {
            vm.filteredProductLines = vm.productLines.filter(function (productLine) {
                return productLine.DivisionID === vm.multiPlayCommissionPolicy.DivisionID
            });
        }
    }

    function filterProductLine(productLine) {
        return !productLine.IsDeleted;
    }

    function filterVisibleProductLine(productLine) {
        return !productLine.IsNew || !productLine.IsDeleted;
    }

    function onAddPolicy() {

        const newArchive = {
            MultiplayCommisionPolicyArchiveID: 0,
            IsNew: true,
            IsDeleted: false,
            ActiveOrderStart: null,
            ActiveOrderEnd: null,
            ActiveInstalledStart: null,
            ActiveInstalledEnd: null,
            MultiPlayCommissionPolicyProductLines: [],
        };
        vm.multiPlayCommissionPolicy.Archives.unshift(newArchive);
        vm.editForm.$setDirty(true);
    }

    function onDeleteArchive(archive) {
        const index = vm.multiPlayCommissionPolicy.Archives.indexOf(archive);
        if (index > -1) {
            archive.editForm.$setValidity("equalProductLines", true);
            archive.editForm.$setValidity("duplicateProductLine", true);
            vm.multiPlayCommissionPolicy.Archives.splice(index, 1);
            validatePolicies();
        }
    }

    function onAddProductLine(archive) {
        const newProductLine = {
            IsNew: true,
            isOpen: true,
            Amount: null
        };
        archive.MultiPlayCommissionPolicyProductLines.unshift(newProductLine);
        vm.editForm.$setDirty(true);
    }

    function onDeleteProductLine(archive, productLine) {
        const index = archive.MultiPlayCommissionPolicyProductLines.indexOf(productLine);
        if (index > -1) {
            archive.editForm.$setValidity("equalProductLines", true);
            archive.editForm.$setValidity("duplicateProductLine", true);
            archive.MultiPlayCommissionPolicyProductLines.splice(index, 1);
            vm.editForm.$setDirty(true);
        }
        validateProductLines();
    }

    function onArchiveChange(archive) {
        archive.editForm.$setValidity("dateComparision", true);
        if (archive.ActiveInstalledEnd && archive.ActiveInstalledStart) {
            archive.editForm.$setValidity("dateComparision", !(moment(archive.ActiveInstalledEnd) < moment(archive.ActiveInstalledStart)));
        }
        if (archive.ActiveOrderEnd && archive.ActiveOrderStart) {
            archive.editForm.$setValidity("dateComparision", !(moment(archive.ActiveOrderEnd) < moment(archive.ActiveOrderStart)));
        }
        validatePolicies();
        archive.editForm.$setDirty(true);
    }


    function onChange(productLine) {
        productLine.ProductLineID = productLine.ProductLine ? productLine.ProductLine.ProductLineID : null;
        validateProductLines();
        productLine.editForm.$setDirty(true);
    }

    function validatePolicies() {
        if (vm.multiPlayCommissionPolicy.Archives.length > 0) {
            const isValidPattern = productCommissionPolicyArchiveService.isValidPolicyPattern(
                vm.multiPlayCommissionPolicy);
            vm.multiPlayCommissionPolicy.IsInvalidPattern = !isValidPattern;
            vm.editForm.$setValidity("patternNotValid", isValidPattern);

            vm.multiPlayCommissionPolicy.Archives.filter(function (archive) {
                return !archive.IsDeleted;
            }).forEach(function (archive) {
                if (archive.ActiveInstalledStart || archive.ActiveOrderStart) {
                    const changes = productCommissionPolicyArchiveService.updateProductCommissionPolicyArchive(
                        vm.multiPlayCommissionPolicy, archive);

                    changes.forEach(function (changedArchive) {
                        changedArchive.editForm.$setDirty(true);
                    });
                }
                const hasConflicts = productCommissionPolicyArchiveService.archiveDatesOverlap(archive,
                    archive.ActiveInstalledStart, archive.ActiveInstalledEnd, archive.ActiveOrderStart,
                    archive.ActiveOrderEnd, vm.multiPlayCommissionPolicy);
                archive.editForm.$setValidity("conflict", !hasConflicts);
            });
            vm.multiPlayCommissionPolicy.errorModelState = null;
            vm.multiPlayCommissionPolicy.Archives.sort(function (a, b) {
                if (a.ActiveOrderStart < b.ActiveOrderStart) {
                    return 1;
                } else if (a.ActiveOrderStart > b.ActiveOrderStart) {
                    return -1;
                } else {
                    if (a.ActiveInstalledStart < b.ActiveInstalledStart) {
                        return 1;
                    } else if (a.ActiveInstalledStart > b.ActiveInstalledStart) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            })[0];
        }
    }

    function validateProductLines() {

        vm.multiPlayCommissionPolicy.Archives.forEach(function (archive) {
            const productLines = archive.MultiPlayCommissionPolicyProductLines
                .map(function (productLine) {
                    return productLine.ProductLineID ? parseInt(productLine.ProductLineID) : null;
                });
            const hasEqualProductLines = productLines.length === vm.multiPlayCommissionPolicy.Count;
            const hasConflicts = productLines.some(function (productLine, idx) {
                return productLines.indexOf(productLine) !== idx
            });

            archive.editForm.$setValidity("equalProductLines", hasEqualProductLines);
            archive.editForm.$setValidity("duplicateProductLine", !hasConflicts);
        });
    }

    function onChangeDivision(multiPlayCommissionPolicy) {
        if (multiPlayCommissionPolicy.Division) {
            multiPlayCommissionPolicy.DivisionID = multiPlayCommissionPolicy.Division.Id;
        }
        if (vm.multiPlayCommissionPolicy.DivisionID) {
            vm.filteredProductLines = vm.productLines.filter(function (productLine) {
                return productLine.DivisionID === vm.multiPlayCommissionPolicy.DivisionID
            });
        }
        multiPlayCommissionPolicy.Archives.forEach(function (archive) {
            archive.MultiPlayCommissionPolicyProductLines.forEach(function (productLines) {
                productLines.ProductLineID = null;
            });
        });
    }

}
